import { Component, HostBinding, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDate, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter } from './services/custom-adapter.service';
import { CustomDateParserFormatter } from './services/custom-date-parser.service';
import { Subject, takeUntil } from 'rxjs';
import { toNgbDate } from '../../utils/convert-to-ngb-date';

@Component({
  selector: 'rx-applications-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DatepickerComponent,
    },
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class DatepickerComponent implements OnDestroy, ControlValueAccessor {
  @HostBinding('class.invalid') @Input() error: string;

  @Input()
  label: string;

  @Input()
  placeholder!: string;

  @Input({ transform: toNgbDate }) minDate: NgbDate = null;

  @Input({ transform: toNgbDate }) startDate: NgbDate = null;

  date: UntypedFormControl = new UntypedFormControl();
  destroyed$: Subject<void> = new Subject<void>();

  onChange = (date: string) => {
    /*On Change*/
  };

  onTouched = () => {
    /*On Touched*/
  };

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
    this.date.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((date: string) => this.onChange(date));
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(date: string): void {
    this.date.setValue(date);
  }
}
